import React from 'react';

const Context = React.createContext({ classes: {} });

export default Context;
